var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5C5A5B",
    fillRule: "evenodd",
    d: "M10 19.375c.55-.001.999-.45 1-1v-3.25h2v3.25c.002.55.45.999 1 1h4a1.005 1.005 0 0 0 1-.992v-5.83l.86.706a.6.6 0 0 0 .321.117c.13 0 .3-.08.384-.18l.32-.383a.6.6 0 0 0 .116-.321.57.57 0 0 0-.18-.385L19 10.61V7.625a.25.25 0 0 0-.25-.25h-1a.25.25 0 0 0-.25.246v1.757l-4.38-3.597c-.269-.223-.77-.405-1.12-.405s-.853.181-1.122.405L3.18 12.107a.57.57 0 0 0-.179.383c0 .1.052.244.117.321l.32.384a.57.57 0 0 0 .383.18.6.6 0 0 0 .32-.117l.86-.705v5.822c0 .55.449.999 1 1zm-.5-1.5h-3v-6.554l5.5-4.52 5.5 4.518-.004 6.556H14.5v-3.25a1.004 1.004 0 0 0-1-1h-3c-.55.002-.998.45-1 1z",
    clipRule: "evenodd"
  })));
};
export default SvgHome;